import { JobsPage } from '@/admin-design/_common/jobs'

// Korean-labelled job names. Anything not in the map renders the raw key
// (useful when a new tick lands before the labels catch up).
const labels: Record<string, string> = {
  'nightly.analysis': '야간 종목분석 (cron)',
  'nightly.run-now': '야간 종목분석 (수동)',
  'nightly.run-now-force': '야간 종목분석 (강제)',
  'plan.resolve-names': '종목명 채우기',
  'news.worker': '뉴스 수집·요약 (cron)',
  'news.run-now': '뉴스 수집·요약 (수동)',
  'news.cluster': '뉴스 클러스터링 (cron)',
  'intraday.analysis': '장중 시황분석 (cron)',
  'intraday.run-now': '장중 시황분석 (수동)',
  'intraday.run-now-force': '장중 시황분석 (강제)',
  'crypto.session': '암호화폐 세션 (cron)',
  'session.tick': '세션 틱 (30s)',
  'tradingcal.refresh': '거래일 캘린더 (cron)',
}

export default function Jobs() {
  return <JobsPage labels={labels} />
}
